/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Aria_ToggleInputs */

const en_nav_aria_toggle = /** @type {(inputs: Nav_Aria_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle menu`)
};

const pt_nav_aria_toggle = /** @type {(inputs: Nav_Aria_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir menu`)
};

const es_nav_aria_toggle = /** @type {(inputs: Nav_Aria_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir menú`)
};

/**
* | output |
* | --- |
* | "Toggle menu" |
*
* @param {Nav_Aria_ToggleInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_aria_toggle = /** @type {((inputs?: Nav_Aria_ToggleInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Aria_ToggleInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_nav_aria_toggle(inputs)
	if (locale === "es") return es_nav_aria_toggle(inputs)
	return en_nav_aria_toggle(inputs)
});